import { Link } from 'react-router-dom';

type Props = {
  eyebrow: string;
  title: string;
  desc?: string;
  actionText?: string;
  actionTo?: string;
};

export default function SectionHeading({ eyebrow, title, desc, actionText, actionTo }: Props) {
  return (
    <div className="mb-6 flex flex-col gap-4 md:mb-8 md:flex-row md:items-end md:justify-between">
      <div>
        <span className="text-xs font-medium uppercase tracking-widest text-primary-600">{eyebrow}</span>
        <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {actionText && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          {actionText}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}